import { render, staticRenderFns } from "./Tipos.vue?vue&type=template&id=4e468c4c&scoped=true&"
import script from "./Tipos.vue?vue&type=script&lang=js&"
export * from "./Tipos.vue?vue&type=script&lang=js&"
import style0 from "./Tipos.vue?vue&type=style&index=0&id=4e468c4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e468c4c",
  null
  
)

export default component.exports